import Store from './Store';
import { ActionTypes } from './actions';
import * as EventTypes from './events';
import { Event } from 'main.core';

const initialState = window.__INITIAL_STATE__ || {

	siteParams: {
		siteId: '',
		siteDir: '',
		templateName: '',
		templatePath: ''
	},

	ui: {
		breakpoints: {
			xs: 0,
			sm: 576,
			md: 768,
			lg: 992,
			xl: 1200,
			xxl: 1488,
		},
		window:{
			fixedScrollbar: false,
			fixScrollbarDeep: 0
		},
		offCanvas: {
			shown: false
		},
		search: {
			shown: false
		},
		modal: {
			activeId: null
		}
	},

	cart: {
		addedIds: new Set(),
		quantityByIds: {}
	},

	wishlist: {
		addedIds: new Set()
	},

	compare: {
		addedIds: new Set()
	},

	location: {
		confirmed: false,
		id: 0,
		data: {}
	}

};

const actions = {

	[ActionTypes.SET_STATE]({ emit, state }, { newState })
	{
		Object.assign(state, { ...newState });

		const data = { state };
		const event = new Event.BaseEvent({ data });
		emit(EventTypes.STATE_UPDATED, event);
	},

	[ActionTypes.UI_OFFCANVAS_SHOW]({ emit, state })
	{
		state.ui.offCanvas.shown = true;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_OFFCANVAS_TOGGLED, event);
		emit(EventTypes.UI_OFFCANVAS_SHOWN, event);
	},

	[ActionTypes.UI_OFFCANVAS_HIDE]({ emit, state })
	{
		state.ui.offCanvas.shown = false;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_OFFCANVAS_TOGGLED, event);
		emit(EventTypes.UI_OFFCANVAS_HIDDEN, event);
	},

	[ActionTypes.UI_OFFCANVAS_TOGGLE]({ emit, state })
	{
		state.ui.offCanvas.shown = !state.ui.offCanvas.shown;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_OFFCANVAS_TOGGLED, event);

		if (state.ui.offCanvas.shown)
			emit(EventTypes.UI_OFFCANVAS_SHOWN, event);
		else
			emit(EventTypes.UI_OFFCANVAS_HIDDEN, event);
	},

	[ActionTypes.UI_SEARCH_SHOW]({ emit, state })
	{
		state.ui.search.shown = true;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_SEARCH_TOGGLED, event);
		emit(EventTypes.UI_SEARCH_SHOWN, event);
	},

	[ActionTypes.UI_SEARCH_HIDE]({ emit, state })
	{
		state.ui.search.shown = false;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_SEARCH_TOGGLED, event);
		emit(EventTypes.UI_SEARCH_HIDDEN, event);
	},

	[ActionTypes.UI_SEARCH_TOGGLE]({ emit, state })
	{
		state.ui.search.shown = !state.ui.search.shown;

		const event = new Event.BaseEvent({ data: { state } });
		emit(EventTypes.UI_SEARCH_TOGGLED, event);

		if (state.ui.search.shown)
			emit(EventTypes.UI_SEARCH_SHOWN, event);
		else
			emit(EventTypes.UI_SEARCH_HIDDEN, event);
	},

	[ActionTypes.UI_SET_ACTIVE_MODAL]({ emit, state }, { id })
	{
		state.ui.modal.activeId = id;
		emit(EventTypes.UI_ACTIVE_MODAL_CHANGED,  new Event.BaseEvent({ data: { state, id } }));
	},

	[ActionTypes.UI_FIX_SCROLLBAR]({ emit, state })
	{
		++state.ui.window.fixScrollbarDeep;

		if (!state.ui.window.fixedScrollbar)
		{
			state.ui.window.fixedScrollbar = true;
			emit(EventTypes.UI_FIXED_SCROLLBAR, new Event.BaseEvent({ data: { state } }));
		}
	},

	[ActionTypes.UI_UNFIX_SCROLLBAR]({ emit, state })
	{
		if (state.ui.window.fixScrollbarDeep > 0)
			--state.ui.window.fixScrollbarDeep;

		if (state.ui.window.fixScrollbarDeep === 0 && state.ui.window.fixedScrollbar)
		{
			state.ui.window.fixedScrollbar = false;
			emit(EventTypes.UI_UNFIXED_SCROLLBAR, new Event.BaseEvent({ data: { state } }));
		}
	},

	[ActionTypes.ADD_ITEM_TO_CART]({ emit, state }, { itemId, quantity })
	{
		state.cart.addedIds.add(itemId);

		if (state.cart.quantityByIds[itemId])
			state.cart.quantityByIds[itemId] += quantity;
		else
			state.cart.quantityByIds[itemId] = quantity;

		emit(EventTypes.CART_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.ADDED_ITEM_TO_CART, new Event.BaseEvent({ data: { state, itemId, quantity } }));
	},

	[ActionTypes.REMOVE_ITEM_FROM_CART]({ emit, state }, { itemId })
	{
		state.cart.addedIds.delete(itemId);

		if (state.cart.quantityByIds[itemId])
			delete state.cart.quantityByIds[itemId];

		emit(EventTypes.CART_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.REMOVED_ITEM_FROM_CART, new Event.BaseEvent({ data: { state, itemId } }));
	},

	[ActionTypes.SET_ITEM_QUANTITY_IN_CART]({ emit, state }, { itemId, quantity })
	{
		if (quantity > 0)
			state.cart.addedIds.add(itemId);
		else
			state.cart.addedIds.add(itemId);

		state.cart.quantityByIds[itemId] = quantity;

		emit(EventTypes.CART_UPDATED, new Event.BaseEvent({ data: { state, itemId} }));
	},

	[ActionTypes.ADD_ITEM_TO_WISHLIST]({ emit, state }, { itemId })
	{
		state.wishlist.addedIds.add(itemId);

		emit(EventTypes.WISHLIST_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.ADDED_ITEM_TO_WISHLIST, new Event.BaseEvent({ data: { state, itemId } }));
	},

	[ActionTypes.REMOVE_ITEM_FROM_WISHLIST]({ emit, state }, { itemId })
	{
		state.wishlist.addedIds.delete(itemId);

		emit(EventTypes.WISHLIST_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.REMOVED_ITEM_FROM_WISHLIST, new Event.BaseEvent({ data: { state, itemId } }));
	},

	[ActionTypes.ADD_ITEM_TO_COMPARE]({ emit, state }, { itemId })
	{
		state.compare.addedIds.add(itemId);

		emit(EventTypes.COMPARE_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.ADDED_ITEM_TO_COMPARE, new Event.BaseEvent({ data: { state, itemId } }));
	},

	[ActionTypes.REMOVE_ITEM_FROM_COMPARE]({ emit, state }, { itemId })
	{
		state.compare.addedIds.delete(itemId);

		emit(EventTypes.COMPARE_UPDATED, new Event.BaseEvent({ data: { state, itemId } }));
		emit(EventTypes.REMOVED_ITEM_FROM_COMPARE, new Event.BaseEvent({ data: { state, itemId } }));
	},

	[ActionTypes.SET_LOCATION]({ emit, state }, { locationId })
	{
		const currentLocation = state.location.id;
		if (currentLocation != locationId)
		{
			state.location.id = locationId;
			emit(EventTypes.LOCATION_CHANGED, new Event.BaseEvent({ data: { locationId } }));
		}
	},

	[ActionTypes.CONFIRM_LOCATION]({ emit, state })
	{
		window.localStorage.setItem('location_confirmed', 'Y'); 
		state.location.confirmed = true;

		emit(EventTypes.LOCATION_CONFIRMED, new Event.BaseEvent());
	}
	
};

export default new Store({ initialState, actions });